import { createTheme, ThemeOptions } from "@mui/material/styles"
import type {} from "@mui/x-date-pickers-pro/themeAugmentation"
import type {} from "@mui/x-date-pickers/themeAugmentation"

// LOCKER-486: a picker popper's focus trap is always enabled (MUI X passes
// `isEnabled: () => true`), so it never yields to a Modal opened on top of it.
// With both open, each trap pulls focus back on the other's focusin until the
// stack overflows. Not enforcing focus in the popper ends the fight; the
// Modal's own trap still enforces focus.
const pickerSlotProps = { desktopTrapFocus: { disableEnforceFocus: true } }

const components: ThemeOptions["components"] = {
  MuiDatePicker: { defaultProps: { slotProps: pickerSlotProps } },
  MuiDateTimePicker: { defaultProps: { slotProps: pickerSlotProps } },
  MuiDateRangePicker: { defaultProps: { slotProps: pickerSlotProps } },
}

export const lightTheme = createTheme({
  palette: {
    primary: {
      main: "#234285",
      // main: "#3A5163",
      //   main: "#F9556D",
    },
    secondary: {
      main: "#94D2C2",
    },
    mode: "light",
  },
  typography: {
    fontFamily: 'Inter, "Helvetica", "Arial", sans-serif',
  },
  components,
})
export const darkTheme = createTheme({
  palette: {
    primary: {
      // white
      main: "#F9F9F9",
    },
    mode: "dark",
  },
  typography: {
    fontFamily: 'Inter, "Helvetica", "Arial", sans-serif',
    // whitesmoke
  },
  components,
})
